import api from "./api";

export async function sendCommand(usinaId, commandObject) {
    const res = await api.post(`equipment-operations/usina/${usinaId}/send-operation`, commandObject);
    return res.data;
}